module.exports = __webpack_public_path__ + "static/media/deals-splash-screen.7572d96a.svg";